import algoliasearch from "algoliasearch";
import firebase from "../../config/firebase";
import { toast } from "react-toastify";
import { createNullCache } from "@algolia/cache-common";
const client = algoliasearch("GPYJEAVUBP", "b1f999bc5b264defe930762391d240c6", {
  responsesCache: createNullCache(),
});

export const addOns =
  (payload, onSuccess = () => {}) =>
  async (dispatch) => {
    try {
      const addOnsRef = firebase.firestore().collection("addOns").doc();
      const docId = addOnsRef.id;

      const imageFile = payload?.image;
      let downloadURL = "";

      if (imageFile) {
        const fileName = imageFile.name;
        const storageRef = firebase
          .storage()
          .ref(`addOns/${docId}/${fileName}`);
        const uploadTaskSnapshot = await storageRef.put(imageFile);
        downloadURL = await uploadTaskSnapshot.ref.getDownloadURL();
      }

      await addOnsRef.set({
        ...payload,
        image: downloadURL,
        createdAt: firebase.firestore.Timestamp.now(),
        updatedAt: firebase.firestore.Timestamp.now(),
      });
      onSuccess();
    } catch (error) {
      toast.error("Failed to add label: " + error.message);
      console.error("Error adding label:", error);
    }
  };

export const fetchAddOns = (id) => (dispatch) => {
  try {
    const unsubscribe = firebase
      .firestore()
      .collection("addOns")
      .where("restaurantId", "==", id)
      .onSnapshot(
        (snapshot) => {
          const addOnsList = snapshot.docs.map((doc) => ({
            id: doc.id,
            ...doc.data(),
          }));

          dispatch({
            type: "FETCH_ADDONS_SUCCESS",
            payload: addOnsList,
          });
        },
        (error) => {
          console.error("Error fetching add-ons:", error);
        }
      );

    return unsubscribe;
  } catch (error) {
    console.error("Snapshot error:", error);
  }
};

export const deleteAddOns =
  (id, imageUrl, onSuccess = () => {}) =>
  async (dispatch) => {
    try {
      if (imageUrl) {
        const storageRef = firebase.storage().refFromURL(imageUrl);
        await storageRef.delete();
      }

      await firebase.firestore().collection("addOns").doc(id).delete();
      onSuccess();
    } catch (error) {
      console.error("Error deleting label:", error);
      toast.error(error.message || "Unable to delete label");
    }
  };

export const editAddOns =
  (id, payload, onSuccess = () => {}, onError = () => {}) =>
  async (dispatch) => {
    try {
      const addOnsRef = firebase.firestore().collection("addOns").doc(id);

      const imageFile = payload?.image;
      if (imageFile instanceof File) {
        const previousImagePath = `addOns/${id}`;
        const previousImageRef = firebase.storage().ref(previousImagePath);
        if (previousImageRef) {
          const files = await previousImageRef.listAll();
          const deletePromises = files.items.map((fileRef) => fileRef.delete());
          await Promise.all(deletePromises).catch((error) => {
            console.error("Error deleting previous images:", error);
          });
        }

        const fileName = imageFile.name;
        const storageRef = firebase
          .storage()
          .ref(`${previousImagePath}/${fileName}`);
        const uploadTaskSnapshot = await storageRef.put(imageFile);
        const downloadURL = await uploadTaskSnapshot.ref.getDownloadURL();

        payload.image = downloadURL;
      }

      await addOnsRef.update({
        ...payload,
        updatedAt: firebase.firestore.Timestamp.now(),
      });
      onSuccess();
    } catch (error) {
      onError();
      console.error("Error updating Add On:", error);
    }
  };

export const getAddOns =
  (id, search, hitsPerPage, currentPage) => async (dispatch) => {
    try {
      const index = client.initIndex("addOns");
      const response = await index.search(search, {
        filters: `restaurantId:${id}`,
        hitsPerPage,
        page: currentPage,
      });

      const { hits, ...rest } = response;
      dispatch({
        type: "GET_ADDONS_SUCCESS",
        payload: {
          hits,
          rest,
        },
      });
    } catch (error) {
      console.error("Error fetching labels:", error);
    }
  };

export const getItemAddOns = async (itemId) => {
  try {
    if (!itemId) throw new Error("Item ID is required");

    const itemRef = firebase.firestore().collection("items").doc(itemId);
    const itemSnap = await itemRef.get();

    if (!itemSnap.exists) {
      throw new Error("Item not found");
    }

    const itemData = itemSnap.data();
    const addOnIDs = itemData.addOns || [];

    if (!addOnIDs.length) {
      return [];
    }
    const addOnDocs = await Promise.all(
      addOnIDs.map((addOnObj) => {
        const addOnID = typeof addOnObj === "string" ? addOnObj : addOnObj?.id;
        if (!addOnID) return null;
        return firebase.firestore().collection("addOns").doc(addOnID).get();
      })
    );

    const addOns = addOnDocs
      .filter((doc) => doc && doc.exists)
      .map((doc) => ({ id: doc.id, ...doc.data() }));

    return addOns;
  } catch (error) {
    console.error("Error fetching item addons:", error);
    return [];
  }
};
